/** Accord distinct de l'opérateur sur l'aperçu serveur exact (contenu + audience). */
export const confirmMarketingPreview = (preview) => window.confirm(
  (preview.category === 'service'
    ? `MESSAGE DE SERVICE : envoyer à ${preview.estimated_recipients} appareil(s) (tous les clients) ?\n` +
      'Aucune promotion autorisée.\n\n'
    : `Envoyer à ${preview.estimated_recipients} appareil(s) consentant(s) ?\n\n`) +
  `Titre : ${preview.title}\nMessage : ${preview.body}\n\n` +
  `Aperçu calculé le ${new Date(preview.observed_at).toLocaleString('fr-FR')}, valable 15 min.`
);
